// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import CardServicio from '../../../componentesEspeciales/cardServicio';
// estilos
import '../../../estilos/usuario.css';



function Favoritos() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    
    // Variables
    const [cargando, setCargando]  = useState(false);
    const cargandoFinal            = Boolean(cargandoUsuario) || Boolean(cargando);
    const [serviciosFavoritos, setServiciosFavoritos] = useState(null);


    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
                const resFavoritos = await axios.post("/obtener-favoritos", {
                    params: {idUsuario: usuario.idUsuario}
                });
                let favoritos = resFavoritos.data.favoritos;
                if(favoritos.length > 0){ setServiciosFavoritos(favoritos); } // SOLO SI EL ARREGLO TRAE SERVICIOS
                
            }
            finally {
                setCargando(false);
            }
        })();
    }, [usuario, cargandoUsuario]);
    

    //console.log(serviciosFavoritos);


    async function eliminarFavorito(servicio){
        
        try{
            const res = await axios.post("/guardar-favorito", {
                params: {
                    existe: true,
                    usuario: usuario,
                    servicio: servicio
                }
            });

            console.log(res.data);

            Swal.fire({
                icon: 'success',
                title: "Éxito",
                text: "Eliminado de favoritos correctamente.",
                customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar', cancelButton: 'mi-boton-cancelar' },
                showCancelButton: false,
                confirmButtonText: 'Continuar'
              }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
              });
        }
        catch(err){
            Swal.fire({
                icon: 'error',
                title: "Error",
                text: "Error eliminando de favoritos. Vuelva a intentar",
                customClass: {
                    popup: 'mi-modal',
                    confirmButton: 'mi-boton-confirmar',
                    cancelButton: 'mi-boton-cancelar'
                },
            });
        }
    }



    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Favoritos</h1>
                    </div>
                </div>
            </div>


            {/* CONTENEDOR FAVORITOS */}
            <div className='container my-5'>
                

                { !serviciosFavoritos ? 
                    <div className="alert alert-tertiary" role="alert"> Aún no tienes servicios en favoritos. </div>
                : <div> 
                <p className="text-muted mb-4">Aquí puedes ver tus favoritos.</p>
                    <div className="row g-3">
                        {(serviciosFavoritos || []).map((servicio) => (
                            <div key={servicio._id || servicio.idServicio} className="col-12 col-md-6 col-lg-4 d-flex mb-5">
                                <div className="d-flex flex-column w-100 h-100">
                                    <div className="flex-grow-1">
                                        <CardServicio servicio={servicio} clampDesc={4} textoBoton="Ver servicio" desdeDonde={"home"} />
                                    </div>

                                    <button onClick={() => eliminarFavorito(servicio)} className='btn btn-danger w-100 mt-2'>Eliminar</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                }
            </div>
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default Favoritos;